/**
 * @fileoverview What this gardener has shared to the gallery, as a query.
 *
 * Where: GalleryQueue (approver), the header (the queue link) and the Public
 * switch (the saved name).
 * API: GET /gallery/mine (getMyGallery).
 * Settings: GALLERY_STALE_MS (config/tunables/garden).
 *
 * @module useMyGallery
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { getMyGallery, type MyGallery } from '@/shared/api/gallery';
import { useAuth } from '@/shared/hooks/useAuth';
import { GALLERY_STALE_MS } from '@/config/tunables/garden';

/** The cache key of the gardener's own gallery state, read again after they share or take back. */
export const MY_GALLERY_KEY = ['gallery', 'mine'] as const;

/** The gardener's gallery state (their shares, saved name, whether they approve), once signed in. */
export function useMyGallery(): UseQueryResult<MyGallery, Error> {
  const { mysqlUser } = useAuth();
  return useQuery({
    queryKey: MY_GALLERY_KEY,
    queryFn: getMyGallery,
    enabled: Boolean(mysqlUser),
    staleTime: GALLERY_STALE_MS,
  });
}

